import { ref, computed } from 'vue';
import subscriptionAPI from '../api/subscription';

const planLimits = ref(null);
const isLoading = ref(false);
const error = ref(null);
const lastChecked = ref(null);

export function usePlanLimits() {
  const isBlocked = computed(() => planLimits.value?.is_blocked || false);
  const isFree = computed(() => planLimits.value?.is_free || false);
  const isExpired = computed(() => planLimits.value?.is_expired || false);
  const blockReason = computed(() => planLimits.value?.reason || null);
  const blockMessage = computed(() => planLimits.value?.message || '');
  const messageCount = computed(() => planLimits.value?.message_count || 0);
  const messageLimit = computed(() => planLimits.value?.message_limit || 0);
  const remainingMessages = computed(
    () => planLimits.value?.remaining_messages || 0
  );
  const planName = computed(() => planLimits.value?.plan_name || '');

  const checkLimits = async (forceRefresh = false) => {
    // Si ya se verificó hace menos de 1 hora y no es forzado, usar cache
    if (!forceRefresh && lastChecked.value) {
      const timeSinceLastCheck = Date.now() - lastChecked.value;
      // 5 minutos = 300000
      // 10 minutos = 600000
      // 30 minutos = 1800000
      // 2 horas = 7200000
      if (timeSinceLastCheck < 3600000) {
        return planLimits.value;
      }
    }

    try {
      isLoading.value = true;
      error.value = null;
      const response = await subscriptionAPI.checkPlanLimits();
      planLimits.value = response.data;
      lastChecked.value = Date.now();

      return planLimits.value;
    } catch (err) {
      error.value = err.message;

      // En caso de error, no bloquear
      planLimits.value = {
        success: false,
        is_blocked: false,
        error: err.message,
      };

      return planLimits.value;
    } finally {
      isLoading.value = false;
    }
  };

  const resetCache = () => {
    planLimits.value = null;
    lastChecked.value = null;
  };

  return {
    planLimits,
    isLoading,
    error,
    isBlocked,
    isFree,
    isExpired,
    blockReason,
    blockMessage,
    messageCount,
    messageLimit,
    remainingMessages,
    planName,
    checkLimits,
    resetCache,
  };
}
